import { withJsonFormsControlProps } from '@jsonforms/react';
import type { ControlProps } from '@jsonforms/core';
import TextField from '@mui/material/TextField';

function formatPhone(digits: string): string {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

function toDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

function PhoneControlComponent({
  data,
  handleChange,
  path,
  label,
  enabled,
  visible,
  required,
  errors,
}: ControlProps) {
  if (!visible) return null;

  const digits = data ? toDigits(String(data)) : '';
  const display = formatPhone(digits);

  return (
    <TextField
      label={label}
      value={display}
      required={required}
      disabled={!enabled}
      error={!!errors}
      helperText={errors}
      fullWidth
      size="small"
      placeholder="(555) 123-4567"
      onChange={(e) => {
        const raw = toDigits(e.target.value);
        handleChange(path, raw || undefined);
      }}
    />
  );
}

export const PhoneControl = withJsonFormsControlProps(PhoneControlComponent);
